import React, { Component } from 'react';
import _ from 'lodash';

import MultiplePositionsUserTable from '../MultiplePositionsUserTable';
import AfterSaveLoading from '../../components/AfterSaveLoading';

import DocumentStore from '../../stores/DocumentStore';

class Order extends Component {
  constructor(){
    super();

    this.state = {
      loading: false,
      note_header: "",
      note_text: "",
      selectedInformeeIds: null,
      showAssigneeTable: false,
      internal_users: []
    }

    this.setNoteHeader = this.setNoteHeader.bind(this);
    this.setNoteText = this.setNoteText.bind(this);
    this.toggleAssignee = this.toggleAssignee.bind(this);
    this.handleSelectInformee = this.handleSelectInformee.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fetchInternalUsers = this.fetchInternalUsers.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
  }

  fetchInternalUsers(){
    let url = 'documents/internal_users';

    DocumentStore.request({url: url}).then((resp)=>{
      var internal_users = _.get(resp.data, 'internal_users', []);

      this.setState({
        internal_users: internal_users
      })
    }).then(()=>{
      this.setState({loading: false});
    })
  }
  
  handleSelectAll(isSelected, rows) {
    if (isSelected) {
      return this.props.internal_users.map(row => row.id);
    } else {
      return [];
    }
  }

  setNoteHeader(event){
    const note_header = event.target.value;
    this.setState({note_header: note_header});
  }

  setNoteText(event){
    const note_text = event.target.value;
    this.setState({note_text: note_text});
  }

  handleSelectInformee(selectedInformeeIds){
    this.setState({ selectedInformeeIds: selectedInformeeIds });
  }

  toggleAssignee(){
    this.setState({
      showAssigneeTable: !this.state.showAssigneeTable,
      loading: !this.state.showAssigneeTable
    }, this.fetchInternalUsers());
  }

  handleSubmit(){
    let note_text = "";

    if(this.state.note_header != ""){
      note_text = this.state.note_header + "\n" + this.state.note_text;
    } else {
      note_text =this.state.note_text;
    }

    if (_.isEmpty(note_text) && !window.confirm('ยืนยันไม่ระบุคำสั่งการ')) { return }

    this.props.onSubmitAction(note_text, this.state.selectedInformeeIds);
  }

  render(){
    return(
      <div>
        {this.state.loading && <AfterSaveLoading />}
        <div className="form-row align-items-center">
          <div className="col-auto">
            รายละเอียดสั่งการ:
          </div>
          <div className="col-auto">
            <select name="note_header" className="form-control form-control-sm" onChange={this.setNoteHeader}>
              <option value="">- คำสั่งการ -</option>
              <option value="อนุมัติ">อนุมัติ</option>
              <option value="อนุมัติ – มอบดังเสนอ">อนุมัติ – มอบดังเสนอ</option>
              <option value="อนุญาต-มอบดังเสนอ">อนุญาต-มอบดังเสนอ</option>
              <option value="ลงนามแล้ว">ลงนามแล้ว</option>
              <option value="มอบดังเสนอ">มอบดังเสนอ</option>
              <option value="ทราบ">ทราบ</option>
              <option value="ทราบ – มอบดังเสนอ">ทราบ – มอบดังเสนอ</option>
              <option value="ทราบเข้าร่วม">ทราบเข้าร่วม</option>
              <option value="แจ้งดังเสนอ">แจ้งดังเสนอ</option>
              <option value="เห็นชอบ-มอบดังเสนอ">เห็นชอบ-มอบดังเสนอ</option>
              <option value="อนุญาต">อนุญาต</option>
            </select>
          </div>
        </div>

        {this.props.workflow_process.attributes.receive_number !== null && (
          <div className="row my-2">
            <div className="col-12">
              <a href="#" onClick={this.toggleAssignee}>
                หากต้องการสั่งการไปยังผู้ดำเนินการโดยตรง กรณีไม่ส่งกลับสารบรรณสำนัก ให้เลือกผู้ดำเนินการโดยตรง
              </a>
            </div>
          </div>
        )}
        
        {this.state.showAssigneeTable && (
          <MultiplePositionsUserTable 
            positions_users={this.state.internal_users}
            selectedIds={this.state.selectedInformeeIds}
            onSelectInformee={this.handleSelectInformee}
            hideClose={true}
            onSelectAll={this.handleSelectAll} />
        )}

        <div className="row">
          <div className="col-12">
            <h4>เพื่อดำเนินการ</h4>
            <textarea cols="30" rows="10" className="w-100" value={this.state.note_text} onChange={this.setNoteText}></textarea>
          </div>
        </div>

        <div className="modal-footer row mt-2">
          <button type='button' className="btn btn-primary pointer" disabled={this.props.clicked} onClick={this.handleSubmit}>ยืนยัน</button>
          <button type='button' className="btn btn-secondary pointer" onClick={this.props.onCloseModal}>ยกเลิก</button>
        </div>
      </div>
    )
  }
}

export default Order;



// WEBPACK FOOTER //
// ./src/components/WorkflowActions/Order.js